import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MenuOverlayComponent } from '@app/shared/components/menu-overlay/menu-overlay';
import { MiscModel } from '@models/misc-model';
import { TranslatePipe } from '@ngx-translate/core';
import { ComponentCodeConstants } from '@shared/component-constants';

@Component({
	selector: 'case-list-item',
	templateUrl: 'case-list-item.html',
	styleUrls: ['./case-list-item.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [MenuOverlayComponent, TranslatePipe]
})
export class CaseListItemComponent implements OnChanges {

	@Input() miscModel: MiscModel;
	@Input() image: (conf: any) => string;
	@Input() selected: boolean;
	@Input() editMode: boolean;
	@Input() variantOrModelIsNew: boolean = false;

	public componentConstants = ComponentCodeConstants;
	public showDetail: boolean = false;
	public showOverlay: boolean = false;

	ngOnChanges(changes: SimpleChanges) {
		if (changes['selected'] && !changes['selected'].firstChange && this.editMode) {
			this.showOverlay = changes['selected'].currentValue;
			new Promise(resolve => setTimeout(resolve, 2500)).then(x => {
				this.showOverlay = false;
			});
		}
	}

	showDetails() {
		this.showDetail = !this.showDetail;
	}

}
